var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('m-image-file-input',{staticClass:"form-image-step__file-input",model:{value:(_vm.localFile),callback:function ($$v) {_vm.localFile=$$v},expression:"localFile"}})
}
var staticRenderFns = []

export { render, staticRenderFns }